import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Vue from 'vue';

const PresetsRepository = RepositoryFactory.get('presets');
const GroupsRepository = RepositoryFactory.get('groups');

const state = {
    changesMade: false,
    presets: [],
    groups: [],
    currentPresetColumns: [],
    currentDetails: [],
    kpis: [],
    completionRate: 0,
    currentPreset: null,
    presetsTableData: {
        showCopyLoader: false,
        showDeleteLoader: false,
        selectedPreset: null,
        presetLoading: false
    },
    tmpFilterData: null, //mydeals filterdata
    updatingPreset: false,
    updatingHeadline: false,
    lastSelectedFilter: null,
    noAccess: false,
};

const getters = {
    selectablePresets(state) {
        let ret = [];
        // eslint-disable-next-line no-undef
        let user_id = parseInt(sso.getSsoUser().id);
        state.presets.forEach((preset) => {
            let valid = false;
            if (preset.public === 1 || preset.user_id === user_id) {
                valid = true;
            } else if (preset.private === 1 && preset.user_id === user_id && preset.author_id === user_id) {
                valid = true;
            }
            if (valid) ret.push(addTableSpecificData(preset));
        });
        return ret;
    },
    presetsTableData(state) {
        let ret = [];
        state.presets.forEach((preset) => {
            ret.push(addTableSpecificData(preset));
        });
        return ret;
    },
    groups(state) {
        let ret = JSON.parse(JSON.stringify(state.groups));
        ret.sort((a, b) => a.name.localeCompare(b.name));
        ret.unshift({id: 0, name: 'Keine Gruppe'});
        return ret;
    }
};

// actions
const actions = {
    async fetch({state, commit}) {
        state.presetsTableData.presetLoading = true;
        try {
            const {data} = await PresetsRepository.get();
            commit('setPresets', {data: data});
            state.presetsTableData.presetLoading = false;
        } catch (e) {
            state.presetsTableData.presetLoading = false;
        }
    },
    async fetchGroups({commit}) {
        const {data} = await GroupsRepository.get();
        commit('setGroups', {data: data});
    },
    async fetchDetails({commit}, payload) {
        const {data} = await PresetsRepository.getPresetDetails(payload.preset_id, payload.dates, payload.presetColumns);
        commit('setDetails', {data: data});
    },
    async fetchKpis({commit}, payload) {
        console.log('fetch kpis store')
        const {data} = await PresetsRepository.getPresetKpis(payload.preset_id, payload.dates, payload.presetColumns);
        commit('setKpis', {data: data});
    },
    async fetchCompletionRate({state, commit}) {
        const {data} = await PresetsRepository.getCompletionRate(state.currentPreset.id, {
            goal_quantity: state.currentPreset.goal_quantity,
            goal_quantity_start: state.currentPreset.goal_quantity_start,
            goal_quantity_end: state.currentPreset.goal_quantity_end
        });
        commit('setCompletionRate', {data: data});
    },
    async setCurrentPreset({commit}, preset_id) {
        try {
            state.noAccess = false;
            const {data} = await PresetsRepository.getPreset(preset_id);
            commit('setCurrentPreset', {data: data});
        } catch (e) {
            if(e.message === 'no access'){
                Vue.noty.error('Kein Zugriff', 10);
                state.noAccess = true;
            } else{
                Vue.noty.error('Das Preset konnte nicht geladen werden', 10);
            }
        }
    },
    async copyPreset({state}, json) {
        try {
            state.presetsTableData.showCopyLoader = true;
            const {data} = await PresetsRepository.copyPreset(json.id, {user_id: json.userId});
            if (data.status === "copied") {
                state.presets.push(data.result);
                Vue.noty.success('Das Preset wurde erfolgreich mit ' + data.result.user.first_name + ' ' + data.result.user.last_name + ' geteilt');
            } else {
                Vue.noty.error('Das Preset konnte nicht geteilt werden');
            }
            state.presetsTableData.showCopyLoader = false;
        } catch (e) {
            state.presetsTableData.showCopyLoader = false;
            Vue.noty.error('Das Preset konnte nicht geteilt werden');
        }

    },
    async deletePreset({state}, json) {
        try {
            state.presetsTableData.showDeleteLoader = true;
            const {data} = await PresetsRepository.deletePreset(json.id);
            if (data.status === "deleted") {
                let index = state.presets.findIndex(x => x.id === data.result.id);
                Vue.delete(state.presets, index);
                if (json.type === "share") {
                    Vue.noty.success('Das Preset wird nicht mehr mit ' + data.result.user.first_name + ' ' + data.result.user.last_name + ' geteilt');
                } else {
                    Vue.noty.success('Das Preset wurde erfolgreich gelöscht');
                }
            } else {
                Vue.noty.error('Es ist ein Fehler aufgetreten');
            }
            state.presetsTableData.showDeleteLoader = false;
        } catch (e) {
            state.presetsTableData.showDeleteLoader = false;
            Vue.noty.error('Es ist ein Fehler aufgetreten');
        }
    },
    async update({state, commit}, columns) {
        try {
            let columnsCopy = JSON.parse(JSON.stringify(columns));
            for (let i = 0; i < columnsCopy.length; i++) {
                //remove emtpy sets
                if (Object.keys(columnsCopy[i]).length === 0) {
                    columnsCopy.splice(i, 1);
                    i--;
                }
                if(typeof columnsCopy[i].pivot.filter_value !== "undefined" && Array.isArray(columnsCopy[i].pivot.filter_value)){
                    columnsCopy[i].pivot.filter_value = columnsCopy[i].pivot.filter_value.join(';');
                }
            }
            state.updatingPreset = true;
            let presetCopy = JSON.parse(JSON.stringify(state.currentPreset));
            presetCopy.columns = columnsCopy;
            const {data} = await PresetsRepository.updatePreset(state.currentPreset.id, presetCopy);
            if (data.status === 'updated') {
                state.updatingPreset = false;
                commit('setCurrentPreset', {data: data});
                Vue.noty.success('Preset erfolgreich gespeichert');
                state.changesMade = false;
            } else {
                Vue.noty.error('Es ist ein Fehler aufgetreten');
            }
        } catch (e) {
            state.updatingPreset = false;
            Vue.noty.error('Es ist ein Fehler aufgetreten');
        }
    },
    async updateLinkState({commit}, payload) {
        try {
            await PresetsRepository.updatePresetLink(payload.id, {extern_link_is_active: payload.active});
            Vue.noty.success('Aktualisierung erfolgreich');
            commit('setActiveLink', payload.active);
        } catch (e) {
            console.log(e);
            Vue.noty.error(e);
        }
    },
    async updateHeadline({state, commit}, data){
        state.updatingHeadline = true;
        let json = JSON.parse(JSON.stringify(data));
        await PresetsRepository.updatePreset(state.currentPreset.id, json)
            .then(response => {
                if (response.data.status === "updated") {
                    commit('updateHeadline', {data: response.data.result});
                    Vue.noty.success('Preset Einstellungen erfolgreich gespeichert');
                }
            })
            .catch(error => {
                Vue.noty.error('Preset Einstellungen konnten nicht gespeichert werden');
                console.error(error);
            });
        state.updatingHeadline = false;
    }
};

// mutations
const mutations = {
    setActiveLink(state, active) {
        state.currentPreset.extern_link_is_active = active;
    },
    setCurrentPreset(state, {data}) {
        state.currentPreset = data.result;
        state.currentPresetColumns = data.result.columns;
    },
    setPresets(state, {data}) {
        state.presets = data;
    },
    setGroups(state, {data}) {
        Vue.set(state, 'groups', data);
        //state.groups = data;
    },
    setDetails(state, {data}) {
        state.currentDetails = data.result.details;
    },
    setKpis(state, {data}) {
        state.kpis = data.result;
    },
    setCompletionRate(state, {data}) {
        state.completionRate = data.result;
    },
    updateGoalQuantity(state, payload) {
        state.changesMade = true;
        state.currentPreset.goal_quantity_start = payload.range.start;
        state.currentPreset.goal_quantity_end = payload.range.end;
        state.currentPreset.goal_quantity = payload.volume;
    },
    updateComment (state, text) {
        state.changesMade = true;
        state.currentPreset.comment = text;
    },
    updateCommentIntern (state, text) {
        state.changesMade = true;
        state.currentPreset.comment_intern = text;
    },
    updateHeadline (state, data) {
        let presetIndex = state.presets.findIndex(x => x.id === data.data.id);
        Vue.set(state.presets[presetIndex], 'name', data.data.name);
        Vue.set(state.presets[presetIndex], 'public', data.data.public);
        Vue.set(state.presets[presetIndex], 'private', data.data.private);
        Vue.set(state.currentPreset, 'name', data.data.name);
        Vue.set(state.currentPreset, 'public', data.data.public);
        Vue.set(state.currentPreset, 'private', data.data.private);
    },
    setChangesMade(state, changesMade) {
        state.changesMade = changesMade;
    },
    setDashboardVisibility(state, visibility) {
        state.currentPreset.visibility_dashboard = visibility;
    },
    setTableVisibility(state, visibility) {
        state.currentPreset.visibility_table = visibility;
    },
    setSelectedPreset(state, {data}) {
        state.presetsTableData.selectedPreset = data;
    },
    resetCurrentPreset(state) {
        state.currentPreset = null;
        state.currentPresetColumns = [];
    },
    updatePresetColumns(state, {data}) {
        state.currentPreset.columns = data;
    },
    addPreset(state, {data}) {
        state.presets.push(data);
    },
    updateLastSelectedFilter(state, {data}) {
        state.lastSelectedFilter = data;
    },
    updateTmpFilterData(state, {data}) {
        state.tmpFilterData = data;
    }
};

function getPresetAuthor(data) {
    if (data.author !== null) {
        return data.author.first_name + ' ' + data.author.last_name;
    } else {
        return 'invalid';
    }
}

function getPresetGroup(data) {
    if (typeof data.group !== "undefined" && data.group !== null && data.group.length !== 0) {
        return data.group[0].name;
    } else {
        return '';
    }
}

function getPresetVisibility(data) {
    if (data.public === 0 && data.private === 1) {
        if (data.author_id !== data.user_id) {
            return 'shared';
        } else {
            return 'private';
        }
    } else if (data.public === 1 && data.private === 0) {
        return 'public';
    } else if (data.public === 1 && data.private === 1) {
        //public ? + share?
        return 'public';
    }
    return 'invalid';
}

function addTableSpecificData(data) {
    let visibility = getPresetVisibility(data);
    data.action = visibility === "private" ? ['share', 'delete'] : ['delete'];
    data.author_name = getPresetAuthor(data);
    data.group_name = getPresetGroup(data);
    data.visibility = visibility;
    return data;
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}